import { PATIENT_HOURS_REPORT, COORDINATOR, SYNC_PH, PHRS } from "../../types";

const initialState = {};
const PatientReducer = (state = initialState, action) => {
    if ([PATIENT_HOURS_REPORT, COORDINATOR, SYNC_PH, PHRS].includes(action.type)) {
        return { ...state, [action.type]: action.payload }
    }
    return state;
}

export default PatientReducer;
